import { media } from "../../design/breakpoints";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";

const TableWrapper = styled.div`
  display: inline-block;
  margin: 1rem auto;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  text-align: center;
`;

const StyledTable = styled.table`
  width: auto;
  min-width: 700px;
  margin: 1rem auto;
  border-collapse: collapse;
  font-size: 0.95rem;

  th, td {
    border: 1px solid #ddd;
    padding: 0.8rem 1.2rem;
    vertical-align: middle;
    white-space: nowrap;
  }

  th {
    background-color: #f4f4f4;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background-color: #fafafa;
  }

  ${media.max600} {
    font-size: 0.8rem;
    min-width: unset;
    th, td {
      padding: 0.4rem 0.6rem;
    }
  }
`;

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export default function WeeklyMotorDetail() {
  const state = useContext(GlobalState);
  const location = useLocation();

  // Get query params
  const queryParams = new URLSearchParams(location.search);
  const motor_id = queryParams.get("motor_id");
  const start = queryParams.get("start");





  const [logs, setLogs] = useState([]);
  const [motorName, setMotorName] = useState("");
  const [totalRuntime, setTotalRuntime] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDetail(token) {
      try {
        const url = `${process.env.REACT_APP_API}/sensor/motor-weekly-runtime?motor_id=${motor_id}&start_date=${start}`;

        const res = await axios.get(url, {
          headers: {
            Authorization: token[0],
          },
        });

        setMotorName(res.data.location);
        setLogs(res.data.days || []);
        setTotalRuntime(res.data.total_weekly_run_time || "");
      } catch (err) {
        console.error("Error fetching weekly details:", err);
      } finally {
        setLoading(false);
      }
    }

    if (motor_id && start) {
      fetchDetail(state.token);
    }
  }, [motor_id, start, state.token]);





  if (loading) {
    return <TableWrapper>Loading weekly details...</TableWrapper>;
  }

  return (
    <TableWrapper>
      {/* <BackButton onClick={handleBack}>
        <FiChevronsLeft size={20} /> Back
      </BackButton> */}

      <h3 style={{ color: "#be6f72", textAlign: "left" }}>
        {motorName} Weekly Details
      </h3>

      <StyledTable>
        <thead>
          <tr>
            <th>Date</th>
            <th>Runtime</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, idx) => (
            <tr key={idx}>
              <td>{formatDate(log.date)}</td>
              <td>{log.run_time}</td>
            </tr>
          ))}
          <tr style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
            <td>Total Weekly Runtime</td>
            <td>{totalRuntime}</td>
          </tr>
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
}
 